import React from 'react'
import CompCicloList from '../components/CompCicloList';
import CompCursoList from '../components/CompCursoList';
import CompTemaList from '../components/CompTemaList';
import FirebaseContext from "../../firebase/context";
import CompCicloListAdd from '../components/CompCicloListAdd';
import CompCursoListAdd from '../components/CompCursoListAdd';
import CompTemaListAdd from '../components/CompTemaListAdd';

import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Container, Button, Typography } from '@material-ui/core';
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';


const style = {
    cardGrid: {
        paddingTop: 8,
        paddingBottom: 8
    },
    paper: {
        backgroundColor: "#f5f5f5",
        padding: "20px",
        minHeight: 650
    },
};

const useStyles = makeStyles((theme) => ({
    button: {
        margin: theme.spacing(1),
    },
    table: {
        minWidth: 700,
    },
    tableHead: {
        // backgroundColor: theme.palette.common.primary,
        backgroundColor: "#29588F",
        // color: theme.palette.common.white,
        Color: "#f5f5f5",
    },
}));


const PagProgramacion = () => {

    const classes = useStyles();


    const { firebase } = React.useContext(FirebaseContext);
    const [ciclos, setCiclos] = React.useState([]);
    const [cicloSelect, setCicloSelect] = React.useState("");
    const [cursos, setCursos] = React.useState([]);
    const [cursoSelect, setCursoSelect] = React.useState("");
    const [temas, setTemas] = React.useState([]);
    const [temaSelect, setTemaSelect] = React.useState("");
    const [showCicloFormAdd, setShowCicloFormAdd] = React.useState(false);
    const [updateCicloList, setUpdateCicloList] = React.useState(0);
    const [showCursoFormAdd, setShowCursoFormAdd] = React.useState(false);
    const [updateCursoList, setUpdateCursoList] = React.useState(0);
    const [didableCursoBtnAdd, setDidableCursoBtnAdd] = React.useState(true);
    const [showTemaFormAdd, setShowTemaFormAdd] = React.useState(false);
    const [updateTemaList, setUpdateTemaList] = React.useState(0);
    const [didableTemaBtnAdd, setDidableTemaBtnAdd] = React.useState(true);
    const [practicaURL, setPracticaURL] = React.useState("");


    //////////////////////////////////////////////////////////////////////////////   
    React.useEffect(() => {
        getIniCiclos();
    }, [showCicloFormAdd, cicloSelect, updateCicloList]);

    function getIniCiclos() {
        firebase.db.collection("colCiclos").get().then(snapshot => {
            const arrayCiclos = snapshot.docs.map(doc => {
                let data = doc.data();
                let id = doc.id;
                return { id, ...data };
            });
            setCiclos(arrayCiclos);
            setUpdateCicloList(0);
        });
    }
    //////////////////////////////////////////////////////////////////////////////
    React.useEffect(() => {
        getIniCursos();
    }, [showCursoFormAdd, cicloSelect, cursoSelect, updateCursoList]);
    function getIniCursos() {

        firebase.db.collection("colCursos").where("idCiclo", "==", cicloSelect).get().then(snapshot => {
            const arrayCursos = snapshot.docs.map(doc => {
                let data = doc.data();
                let id = doc.id;
                return { id, ...data };
            });
            setCursos(arrayCursos);
            setUpdateCursoList(0);
            setTemas([]);
        });
    }
    //////////////////////////////////////////////////////////////////////////////
    React.useEffect(() => {

        getIniTemas();
    }, [cursoSelect, showTemaFormAdd, temaSelect, updateTemaList]);
    function getIniTemas() {

        firebase.db.collection("colTemas").where("idCurso", "==", cursoSelect).get().then(snapshot => {
            const arrayTemas = snapshot.docs.map(doc => {
                let data = doc.data();
                let id = doc.id;
                return { id, ...data };
            });
            setTemas(arrayTemas);
        });
    }
    //////////////////////////////////////////////////////////////////////////////

    return (
        <Container style={style.cardGrid}>

            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="customized table">
                    <TableHead className={classes.tableHead}>
                        <TableRow>
                            <TableCell >
                                <Typography style={{ color: '#FFFFFF' }} >CICLOS</Typography>
                            </TableCell>
                            <TableCell></TableCell>

                            <TableCell align="right">
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    className={classes.button}
                                    startIcon={<LibraryAddIcon />}
                                    onClick={() => setShowCicloFormAdd(true)}
                                >
                                    AGREGAR
                               </Button>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {showCicloFormAdd
                            ? <CompCicloListAdd setShowCicloFormAdd={setShowCicloFormAdd} />
                            : null
                        }
                        {ciclos.map((ciclo, index) => (
                            <CompCicloList
                                key={ciclo.id}
                                ciclo={ciclo}
                                index={index + 1}
                                setCicloSelect={setCicloSelect}
                                setUpdateCicloList={setUpdateCicloList}
                                setDidableCursoBtnAdd={setDidableCursoBtnAdd}
                            />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>


            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="customized table">
                    <TableHead className={classes.tableHead}>
                        <TableRow>
                            <TableCell >
                                <Typography style={{ color: '#FFFFFF' }} >CURSOS</Typography>
                            </TableCell>
                            <TableCell></TableCell>
                            <TableCell align="right">
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    className={classes.button}
                                    startIcon={<LibraryAddIcon />}
                                    disabled={didableCursoBtnAdd}
                                    onClick={() => setShowCursoFormAdd(true)}
                                >
                                    AGREGAR
                               </Button>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {showCursoFormAdd
                            ? <CompCursoListAdd cicloSelect={cicloSelect} setShowCursoFormAdd={setShowCursoFormAdd} />
                            : null
                        }

                        {cursos.map((curso, index) => (
                            <CompCursoList
                                key={curso.id}
                                curso={curso}
                                index={index + 1}
                                setCursoSelect={setCursoSelect}
                                setUpdateCursoList={setUpdateCursoList}
                                setDidableTemaBtnAdd={setDidableTemaBtnAdd}

                            />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>


            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="customized table">
                    <TableHead className={classes.tableHead}>
                        <TableRow>
                            <TableCell >
                                <Typography style={{ color: '#FFFFFF' }} >TEMAS</Typography>
                            </TableCell>
                            <TableCell></TableCell>
                            <TableCell align="right">
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    className={classes.button}
                                    startIcon={<LibraryAddIcon />}
                                    disabled={didableTemaBtnAdd}
                                    onClick={() => setShowTemaFormAdd(true)}
                                >
                                    AGREGAR
                               </Button>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {showTemaFormAdd
                            ? <CompTemaListAdd
                                cursoSelect={cursoSelect}
                                setShowTemaFormAdd={setShowTemaFormAdd}
                                setPracticaURL={setPracticaURL}
                                practicaURL={practicaURL}
                            />
                            : null
                        }
                        {temas.map((tema, index) => (
                            <CompTemaList
                                key={tema.id}
                                tema={tema}
                                index={index + 1}
                                setTemaSelect={setTemaSelect}
                                setUpdateTemaList={setUpdateTemaList}
                                setDidableTemaBtnAdd={setDidableTemaBtnAdd}
                                setPracticaURL={setPracticaURL}
                                practicaURL={practicaURL}
                            />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Container>
    )
}

export default PagProgramacion
